"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TgwalletConnector = void 0;
const ws_connector_1 = require("./ws-connector");
const iconnector_1 = require("./iconnector");
const utils_1 = require("../utils");
class TgwalletConnector extends ws_connector_1.WsConnector {
    constructor() {
        super();
        this.walletName = 'OKX Mini Wallet';
        this.walletNameKey = 'walletModal.mobileConnectionModal.connectMini';
    }
    getTag() {
        return iconnector_1.OKX_TG_WALLET;
    }
    openWallet(engineConnectInfo, openAppLinkType) {
        var _a;
        var encodeTGParams;
        if (engineConnectInfo && engineConnectInfo.connectRequest) {
            encodeTGParams = (0, utils_1.encodeTWAConnectURLParams)(Object.assign(Object.assign({}, engineConnectInfo.connectRequest), { redirect: "none" }));
        }
        var tgUrl = (0, utils_1.getTelegramWalletTWAUrl)(encodeTGParams, (_a = engineConnectInfo === null || engineConnectInfo === void 0 ? void 0 : engineConnectInfo.tmaReturnUrl) !== null && _a !== void 0 ? _a : "back");
        (0, utils_1.openOKXTMAWalletlinkWithFallback)(tgUrl);
    }
}
exports.TgwalletConnector = TgwalletConnector;
